// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"./styles/_colors.css\"","background":"#f6f8fa"};